import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { RoleFilters, RoleSlice } from "./rolesTypes.ts";

const initialState: RoleSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<RoleSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<RoleSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof RoleFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<RoleSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  rolesSlice.actions;

export const selectPage = (state: RootState) => state.roles.page;
export const selectRowsPerPage = (state: RootState) => state.roles.rowsPerPage;
export const selectFilter = (state: RootState) => state.roles.filter;
export const selectSort = (state: RootState) => state.roles.sort;

export default rolesSlice.reducer;
